import { EDashletType } from '../dashlets-enums';
import { TNewDashletData } from './new-dashlet-data.model';

export const ADVANCED_DASHLETS: TNewDashletData[] = [
  {
    key: 'dashlets_live_priority',
    value: EDashletType.CURRENT_PRIORITY,
    icon: 'assets/images/dashlet-preview/live-priority.png',
    preview_url: 'assets/images/dashlet-preview/live-priority.svg',
  },
  {
    key: 'dashlets_live_status',
    value: EDashletType.CURRENT_STATUS,
    icon: 'assets/images/dashlet-preview/live-status.png',
    preview_url: 'assets/images/dashlet-preview/live-status.svg',
  },
  {
    key: 'dashlet_over_time_status',
    value: EDashletType.OVER_TIME_STATUS,
    icon: 'assets/images/dashlet-preview/over-time-status.png',
    preview_url: 'assets/images/dashlet-preview/status-over-time.svg',
  },
  {
    key: 'dashlet_over_time_priority',
    value: EDashletType.OVER_TIME_PRIORITY,
    icon: 'assets/images/dashlet-preview/over-time-priority.png',
    preview_url: 'assets/images/dashlet-preview/priority-over-time.svg',
  },
];

export const ADVANCED_DASHLETS_ASSET: TNewDashletData[] = [
  {
    key: 'dashlet_stacked_status',
    value: EDashletType.CURRENT_STACKED_STATUS,
    icon: 'assets/images/dashlet-preview/over-time-status.png',
    preview_url: 'assets/images/dashlet-preview/stacked-status-preview.svg',
  },
  {
    key: 'dashlet_cost_comparison',
    value: EDashletType.COST_COMPARISON,
    icon: 'assets/images/dashlet-preview/cost-comparison.svg',
    preview_url: 'assets/images/dashlet-preview/cost-comparison-preview.svg',
  },
  {
    key: 'dashlet_value_breakdown',
    value: EDashletType.VALUE_BREAKDOWN,
    icon: 'assets/images/dashlet-preview/value-breakdown.svg',
    preview_url: 'assets/images/dashlet-preview/value-breakdown-preview.svg',
  },
];
